"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hitagi_constraints_1 = __importDefault(require("./hitagi_constraints"));
const hitagi_stream_1 = __importDefault(require("./hitagi_stream"));
/** Hitagi media plugin */
class Hitagi_Plugin_Media {
    constructor(Hitagi) {
        this.local_stream = undefined;
        this.streaming = false;
        this.paused = false;
        this.snapshotVideo = undefined;
        this.snapshotWidth = 256;
        this.snapshotHeight = 192;
        this.lastSnapshot = "";
        this.lastScreenshot = "";
        this.constraints = undefined;
        this.on_local_stream_success = function (event) { };
        this.on_local_stream_error = function (event) { };
        this.switch_media_devices_promise = undefined;
        this.get_user_media_promise = undefined;
        this.hitagi = Hitagi;
        let get_user_media_func = function (Constraints) {
            const result = new Promise((resolve, reject) => {
                reject("navigator.getUserMedia is not supported");
            });
            return result;
        };
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            get_user_media_func = this.get_user_media_modern;
        }
        else if (navigator.webkitGetUserMedia || navigator.mozGetUserMedia) {
            get_user_media_func = this.get_user_media_legacy;
        }
        this.get_user_media_func = get_user_media_func;
    }
    /**
     * Capture user media with given constraints
     * @param media_constraints media constraints for video and audio
     * @param success function that will be called on every successfull capture.
     *                 It also will be called on successfull switch_devices
     *                 call. For one-time handler use .then method of result
     *                 promise. Can be replaced with consecutive call to
     *                 get_user_media
     * @param error function that will be called on every failed capture.
     *               It also will be called on failed switch_devices call.
     *               For one-time handler use .catch method of result promise
     * @returns Promise
     */
    get_user_media(media_constraints, success, error) {
        let constraints = media_constraints;
        if (!media_constraints.get) {
            constraints = new hitagi_constraints_1.default(media_constraints);
        }
        if (typeof success == "function") {
            this.on_local_stream_success = success;
        }
        if (typeof error == "function") {
            this.on_local_stream_error = error;
        }
        //let constraints = new Hitagi_Constraints(media_constraints);
        let enableAudioProcessing = false;
        if (media_constraints.audio) {
            enableAudioProcessing = media_constraints.audio.echoCancellation ? true : false;
        }
        constraints.enable_audio_processing(enableAudioProcessing);
        constraints.set_echo_cancellation_type("system");
        this.constraints = constraints;
        const p = new Promise((resolve, reject) => {
            this.get_user_media_func(constraints.get())
                .then((event) => {
                event.hitagi_constraints = constraints;
                resolve(event);
                this.get_user_media_success(event);
            })
                .catch((event) => {
                // Let's clear devicesID and try again
                this.get_user_media_func(constraints.get_without_devices())
                    .then((event2) => {
                    event2.hitagi_constraints = constraints;
                    resolve(event2);
                    this.get_user_media_success(event2);
                })
                    .catch((event2) => {
                    reject({ event: event2 });
                    this.get_user_media_error(event2);
                });
            });
        });
        return p;
    }
    get_user_media_success(event) {
        if (this.local_stream) {
            this.local_stream.set_stream(event);
        }
        else {
            this.local_stream = new hitagi_stream_1.default(event);
            this.local_stream.mute();
        }
        this.on_local_stream_success(event);
        const Video = document.createElement("video");
        Video.autoplay = true;
        Video.srcObject = event;
        Video.oncanplay = function () {
            Video.play();
        };
        Video.muted = true;
        //if (this.local_stream.is_muted()) {
        //	Video.muted = true;
        //}
        const play_promise = Video.play();
        if (typeof play_promise == "object") {
            play_promise.catch(function (e) { });
        }
        this.snapshotVideo = Video;
        return event;
    }
    get_user_media_error(event) {
        this.on_local_stream_error(event);
    }
    screenshot(video, width, height) {
        const canvas = document.createElement("canvas");
        if (video.paused || video.ended)
            return "";
        if (!width) {
            width = video.videoWidth;
        }
        if (!height) {
            height = video.videoHeight;
        }
        canvas.width = width;
        canvas.height = height;
        const scaleX = width / video.videoWidth;
        const scaleY = height / video.videoHeight;
        const scale = Math.max(scaleX, scaleY);
        const sx = (video.videoWidth - width / scale) / 2;
        const sy = (video.videoHeight - height / scale) / 2;
        const swidth = width / scale;
        const sheight = height / scale;
        const context = canvas.getContext("2d");
        if (context) {
            context.drawImage(video, sx, sy, swidth, sheight, 0, 0, width, height);
            this.lastScreenshot = canvas.toDataURL("image/jpeg");
        }
        return this.lastScreenshot;
    }
    setSnapshotVideoSource(videoElement) {
        this.snapshotVideo = videoElement;
    }
    snapshot() {
        if (this.local_stream && !this.local_stream.is_paused()) {
            if (!this.snapshotVideo)
                return this.lastSnapshot;
            const Video = this.snapshotVideo;
            const Snapshot = this.screenshot(Video, this.snapshotWidth, this.snapshotHeight);
            this.lastSnapshot = Snapshot;
        }
        return this.lastSnapshot;
    }
    getLastScreenshot() {
        return this.lastScreenshot;
    }
    switch_devices(media_constraints) {
        if (this.local_stream) {
            this.local_stream.stop();
            this.hitagi.stream.stop();
        }
        const result = this.get_user_media(media_constraints);
        this.switch_media_devices_promise = result;
        return result;
    }
    getDeviceId(kind) {
        if (!this.local_stream)
            return "no__device";
        return this.local_stream.getDeviceId(kind);
    }
    talk() {
        if (!this.local_stream)
            return;
        this.local_stream.talk();
        this.hitagi.stream.talk();
    }
    mute() {
        if (!this.local_stream)
            return;
        this.local_stream.mute();
        this.hitagi.stream.mute();
    }
    pause() {
        if (!this.local_stream)
            return;
        this.local_stream.pause();
        this.hitagi.stream.pause();
    }
    play() {
        if (!this.local_stream)
            return;
        this.local_stream.play();
        this.hitagi.stream.play();
    }
    // Just return standard, modern promise
    get_user_media_modern(Constraints) {
        //console.log(Constraints);
        return navigator.mediaDevices.getUserMedia(Constraints);
    }
    // Wrap legacy, prefixed code in promise
    get_user_media_legacy(Constraints) {
        let get_user_media_legacy_func = function (c, r1, r2) { throw ("No user media support"); };
        if (navigator.webkitGetUserMedia) {
            get_user_media_legacy_func = navigator.webkitGetUserMedia.bind(navigator);
        }
        else if (navigator.mozGetUserMedia) {
            get_user_media_legacy_func = navigator.mozGetUserMedia;
        }
        const promise_func = (resolve, reject) => {
            get_user_media_legacy_func(Constraints, resolve, reject);
        };
        return new Promise(promise_func);
    }
}
exports.default = Hitagi_Plugin_Media;



//////////////////
// WEBPACK FOOTER
// ./node_modules/hitagi-js/build/hitagi_plugin_media.js
// module id = ./node_modules/hitagi-js/build/hitagi_plugin_media.js
// module chunks = main